import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4acbc36d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "right-align full-width" }


import store from '../store'
import { defineComponent, ref } from 'vue'
import { apiPostData, showRequestResult, getI18n } from '../utils'

// 解决vs中的语法错误提示
const __default__ = defineComponent({
  name: 'ChangePasswordPage'
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const refOldPassword = ref('')
const refNewPassword = ref('')
const refConfirmPassword = ref('')
const onSubmit = () => {
  const postData = { oldPassWord: refOldPassword.value, newPassword: refNewPassword.value, confirmPassword: refConfirmPassword.value }
  console.log('postData=', postData)
  apiPostData('/action?__action_id=__update_password', postData)
    .then(data => {
      showRequestResult(data, '修改', '修改', '', true, true, true)
    })
}

return (_ctx: any,_cache: any) => {
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "label-width": "auto",
    style: {"max-width":"600px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form_item, {
        label: _unref(getI18n)('账户')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_text, { class: "mx-1" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(store).state.userAccount), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _unref(getI18n)('旧密码')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: refOldPassword.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((refOldPassword).value = $event)),
            type: "password"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _unref(getI18n)('新密码')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: refNewPassword.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refNewPassword).value = $event)),
            type: "password"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _unref(getI18n)('确认密码')
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_input, {
            modelValue: refConfirmPassword.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((refConfirmPassword).value = $event)),
            type: "password"
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: onSubmit
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getI18n)('修改')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})